import { p } from "./_helpers";

const logistique = {
 slug: "logistique",
 path: "/secteurs/logistique",
 hero: {
 image: "/photos/sector-logistique-hero.jpg",
 alt: p("Entrepôt logistique en Afrique de l'Ouest", "Logistics warehouse in West Africa", "Armazém logístico na África Ocidental"),
 breadcrumb: p("Logistique", "Logistics", "Logística"),
 title: p("Investir dans la logistique.", "Investing in logistics.", "Investir na logística."),
 subtitle: p(
 "Corridor Bissau–port de ouverture CEDEAO : un carrefour transfrontalier stratégique.",
 "Bissau–corridor, port of ECOWAS opening: a strategic cross-border crossroads.",
 "Corredor Bissau–porto de Bissau, abertura CEDEAO: um cruzamento transfronteiriço estratégico."
 ),
 },
 seo: {
 title: p(
 "Investir dans la logistique en Guinée-Bissau | NANDA SÁ",
 "Investing in logistics in Guinea-Bissau | NANDA SÁ",
 "Investir na logística na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama de la logistique en Guinée-Bissau : corridor Bissau-port de Bissau, ouverture CEDEAO. Chiffres clés, opportunités, défis et passerelles NANDA SÁ.",
 "Panorama of logistics in Guinea-Bissau: Bissau-corridor, port of Bissau, ECOWAS opening. Key figures, opportunities, challenges and NANDA SÁ pathways.",
 "Panorama da logística na Guiné-Bissau: corredor Bissau-porto de Bissau, abertura CEDEAO. Dados-chave, oportunidades, desafios e pontes NANDA SÁ."
 ),
 keywords: "logistique Guinée-Bissau, corridor Bissau port de Bissau, entrepôts CEDEAO, transit Afrique de l'Ouest",
 },
 presentation: {
 title: p("Un carrefour à structurer.", "A crossroads to structure.", "Um cruzamento a estruturar."),
 paragraphs: p(
 [
 "La Guinée-Bissau occupe une position rare en Afrique de l'Ouest : elle est à la fois membre de la CEDEAO, membre de l'UEMOA, voisine directe de Guinée-Bissau et connectée à la Guinée. Le corridor Bissau–Cacheu est déjà l'un des plus dynamiques de la sous-région et son activité continue de croître avec l'intégration commerciale ouest-africaine.",
 "Ce positionnement géographique reste sous-exploité par manque d'entrepôts modernes, de transitaires professionnels et d'infrastructures logistiques certifiées. Les opérateurs sérieux qui s'y installent aujourd'hui construisent un actif rare à l'échelle régionale.",
 ],
 [
 "Guinea-Bissau holds a rare position in West Africa: it is both a member of ECOWAS, a member of WAEMU, a direct neighbour of Guinea-Bissau and connected to Guinea. The Bissau–corridor is already one of the most dynamic in the sub-region and its activity continues to grow with West African commercial integration.",
 "This geographic positioning remains underexploited due to a lack of modern warehouses, professional freight forwarders and certified logistics infrastructure. Serious operators who settle in today are building a rare asset at the regional scale.",
 ],
 [
 "A Guiné-Bissau ocupa uma posição rara na África Ocidental: é simultaneamente membro da CEDEAO, membro da UEMOA, vizinha directa do Guinea-Bissau e ligada à Guiné. O corredor Bissau–já é um dos mais dinâmicos da sub-região e a sua actividade continua a crescer com a integração comercial oeste-africana.",
 "Este posicionamento geográfico permanece sub-explorado por falta de armazéns modernos, de despachantes profissionais e de infra-estruturas logísticas certificadas. Os operadores sérios que se instalam hoje constroem um activo raro à escala regional.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de la logistique", "Logistics key figures", "Dados-chave da logística"),
 items: [
 { n: "CEDEAO", l: p("Marché intégré", "Integrated market", "Mercado integrado"), d: p("15 pays, 400+ millions d'habitants.", "15 countries, 400+ million people.", "15 países, 400+ milhões de habitantes.") },
 { n: "UEMOA", l: p("Union monétaire", "Monetary union", "União monetária"), d: p("Franc CFA, cadre financier commun.", "CFA Franc, common financial framework.", "Franco CFA, enquadramento financeiro comum.") },
 { n: "150 km", l: p("Bissau → Bafatá", "Bissau → Bafatá", "Bissau → Bafatá"), d: p("Corridor transfrontalier en forte activité.", "Highly active cross-border corridor.", "Corredor transfronteiriço em forte actividade.") },
 { n: "1", l: p("Port principal", "Main port", "Porto principal"), d: p("Port de Bissau, en modernisation.", "Port of Bissau, being modernised.", "Porto de Bissau, em modernização.") },
 { n: "2h", l: p("De Bissau par avion", "From Bissau by air", "De Bissau por avião"), d: p("Hub aérien secondaire accessible.", "Accessible secondary air hub.", "Hub aéreo secundário acessível.") },
 { n: "Rare", l: p("Entrepôts certifiés", "Certified warehouses", "Armazéns certificados"), d: p("Ouverture immédiate d'un marché B2B.", "Immediate B2B market opening.", "Abertura imediata de um mercado B2B.") },
 ],
 sources: p(
 "Sources : CEDEAO, UEMOA, ministère des Transports Guinée-Bissau, Banque africaine de développement, données 2023-2025.",
 "Sources: ECOWAS, WAEMU, Guinea-Bissau Ministry of Transport, African Development Bank, data 2023-2025.",
 "Fontes: CEDEAO, UEMOA, Ministério dos Transportes Guiné-Bissau, Banco Africano de Desenvolvimento, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments logistiques prioritaires, avec des tickets d'entrée variés.",
 "Four priority logistics segments, with varied entry tickets.",
 "Quatro segmentos logísticos prioritários, com tickets de entrada variados."
 ),
 segments: [
 { h3: p("1. Entrepôts logistiques modernes (Bissau, Canchungo)", "1. Modern logistics warehouses (Bissau, Canchungo)", "1. Armazéns logísticos modernos (Bissau, Canchungo)"),
 p: p("Standards internationaux, sécurisation, traçabilité. Locataires : cajou, agroalimentaire, ONG. Ticket : 300 000 à 1,5 M€.", "International standards, security, traceability. Tenants: cashew, agri-food, NGOs. Ticket: €300k to €1.5M.", "Padrões internacionais, segurança, rastreabilidade. Arrendatários: caju, agroalimentar, ONG. Ticket: 300 000 a 1,5 M€.") },
 { h3: p("2. Transitaires & courtiers en douane", "2. Freight forwarders & customs brokers", "2. Despachantes e corretores aduaneiros"),
 p: p("Service peu structuré aujourd'hui, forte demande pour l'export. Ticket : 30 000 à 150 000 €.", "Service poorly structured today, strong export demand. Ticket: €30k to €150k.", "Serviço pouco estruturado hoje, forte procura para a exportação. Ticket: 30 000 a 150 000 €.") },
 { h3: p("3. Transport routier réfrigéré", "3. Refrigerated road transport", "3. Transporte rodoviário refrigerado"),
 p: p("Corridor Bissau–Bissau en tension pour poisson, mangue, produits laitiers. Ticket : 100 000 à 500 000 € pour flotte initiale.", "Bissau–Bissau corridor in demand for fish, mango, dairy. Ticket: €100k to €500k for initial fleet.", "Corredor Bissau–Bissau em tensão para peixe, manga, lácteos. Ticket: 100 000 a 500 000 € para frota inicial.") },
 { h3: p("4. Plateformes de distribution B2B", "4. B2B distribution platforms", "4. Plataformas de distribuição B2B"),
 p: p("Grossistes, cash & carry, marketplaces régionales. Marché urbain émergent. Ticket : 200 000 à 800 000 €.", "Wholesalers, cash & carry, regional marketplaces. Emerging urban market. Ticket: €200k to €800k.", "Grossistas, cash & carry, marketplaces regionais. Mercado urbano emergente. Ticket: 200 000 a 800 000 €.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "La logistique est un métier de discipline. En Guinée-Bissau, elle demande aussi de la patience diplomatique.",
 "Logistics is a business of discipline. In Guinea-Bissau, it also requires diplomatic patience.",
 "A logística é um ofício de disciplina. Na Guiné-Bissau, exige também paciência diplomática."
 ),
 items: p(
 [
 "Un port de Bissau à la capacité limitée, en cours de modernisation.",
 "Des procédures douanières encore lourdes, à optimiser avec des partenaires locaux fiables.",
 "Des infrastructures routières inégales, notamment vers les régions productrices.",
 "Une informalité importante du secteur, qui rend la concurrence structurée d'autant plus valorisée.",
 "Un besoin de digitalisation (tracking, gestion, facturation), une opportunité pour les nouveaux entrants.",
 ],
 [
 "A port of Bissau with limited capacity, being modernised.",
 "Still cumbersome customs procedures, to be optimised with reliable local partners.",
 "Uneven road infrastructure, particularly to producing regions.",
 "Significant informality in the sector, which makes structured competition all the more valued.",
 "A need for digitalisation (tracking, management, invoicing), an opportunity for newcomers.",
 ],
 [
 "Um porto de Bissau com capacidade limitada, em modernização.",
 "Procedimentos aduaneiros ainda pesados, a optimizar com parceiros locais fiáveis.",
 "Infra-estruturas rodoviárias desiguais, nomeadamente para as regiões produtoras.",
 "Uma informalidade importante do sector, que torna a concorrência estruturada tanto mais valorizada.",
 "Uma necessidade de digitalização (tracking, gestão, facturação), uma oportunidade para novos operadores.",
 ]
 ),
 closing: p(
 "Ces défis sont exactement ce qui donne de la valeur à ceux qui, aujourd'hui, prennent la peine de bien faire.",
 "These challenges are exactly what gives value to those who, today, take the trouble to do it right.",
 "Estes desafios são exactamente o que confere valor a quem, hoje, se dá ao trabalho de o fazer bem."
 ),
 },
 pourquoi: {
 title: p("Un partenaire aux carrefours de la sous-région.", "A partner at the sub-region's crossroads.", "Um parceiro nos cruzamentos da sub-região."),
 paragraphs: p(
 [
 "NANDA SÁ opère quotidiennement entre la Guinée-Bissau, connaît les douanes des deux pays, les transitaires, les autorités portuaires. Nous concevons les projets logistiques comme des infrastructures durables, non comme des opérations d'opportunité.",
 "Notre pôle Conseil en implantation accompagne les investisseurs dans la structuration complète de leur projet : foncier, permis, partenariats, digitalisation, recrutement.",
 ],
 [
 "NANDA SÁ operates daily between Guinea-Bissau, knows customs in both countries, freight forwarders, port authorities. We design logistics projects as durable infrastructure, not as opportunistic ventures.",
 "Our Establishment Advisory supports investors in the full structuring of their project: land, permits, partnerships, digitalisation, recruitment.",
 ],
 [
 "A NANDA SÁ opera quotidianamente entre a Guiné-Bissau, conhece as alfândegas dos dois países, os despachantes, as autoridades portuárias. Concebemos os projectos logísticos como infra-estruturas duradouras, não como operações oportunistas.",
 "A nossa Consultoria de implantação acompanha os investidores na estruturação completa do seu projecto: imobiliário, licenças, parcerias, digitalização, recrutamento.",
 ]
 ),
 bullets: p(
 [
 "Étude d'implantation d'entrepôt ou plateforme",
 "Structuration douanière et régime import/export",
 "Partenariats transitaires et douaniers",
 "Digitalisation logistique (TMS, WMS)",
 "Recrutement d'équipes locales qualifiées",
 ],
 [
 "Warehouse or platform siting study",
 "Customs structuring and import/export regime",
 "Freight forwarder and customs partnerships",
 "Logistics digitalisation (TMS, WMS)",
 "Recruitment of qualified local teams",
 ],
 [
 "Estudo de implantação de armazém ou plataforma",
 "Estruturação aduaneira e regime import/export",
 "Parcerias com despachantes e aduaneiros",
 "Digitalização logística (TMS, WMS)",
 "Recrutamento de equipas locais qualificadas",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Logistique · Guinée-Bissau ».", "Download the brief « Logistics · Guinea-Bissau ».", "Descarregar a nota « Logística · Guiné-Bissau »."),
 body: p(
 "Une note préparée par NANDA SÁ : chiffres clés, segments d'investissement, cadre régional et contacts utiles.",
 "A brief prepared by NANDA SÁ: key figures, investment segments, regional framework and useful contacts.",
 "Uma nota preparada pela NANDA SÁ: dados-chave, segmentos de investimento, enquadramento regional e contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-logistique.pdf",
 pdfFilename: "nanda-sa-note-logistique.pdf",
 mailSubject: p("Téléchargement de la note « Logistique · Guinée-Bissau »", "Download of the brief « Logistics · Guinea-Bissau »", "Descarga da nota « Logística · Guiné-Bissau »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Logistique · Guinée-Bissau ». Merci de me tenir informé(e) des prochaines publications de NANDA SÁ.",
 "Hello, I would like to receive the brief « Logistics · Guinea-Bissau ». Please keep me informed of NANDA SÁ's next publications.",
 "Olá, gostaria de receber a nota « Logística · Guiné-Bissau ». Por favor, mantenha-me informado(a) das próximas publicações da NANDA SÁ."
 ),
 },
 contact: {
 title: p("Parlons de votre projet logistique.", "Let's talk about your logistics project.", "Falemos do seu projecto logístico."),
 body: p(
 "Transitaire, transporteur, gestionnaire d'entrepôts, distributeur, investisseur : décrivez votre intention, nous répondons personnellement.",
 "Freight forwarder, transporter, warehouse manager, distributor, investor: describe your intention, we respond personally.",
 "Despachante, transportador, gestor de armazéns, distribuidor, investidor: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Un pont ne se voit qu'une fois qu'on l'a construit. C'est pourtant à cet instant précis qu'il change tout.",
 "A bridge is only seen once built. Yet it is precisely at that moment that it changes everything.",
 "Uma ponte só se vê depois de construída. É contudo nesse momento preciso que muda tudo."
 ),
 subject: p("Investir dans la logistique en Guinée-Bissau", "Invest in logistics in Guinea-Bissau", "Investir na logística na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default logistique;
